<template>
  <div :class="['process-content','process-editor', 'layout_type_1' ]">
<!--  <div class="layout_type_4">-->
    <!-- layout_type_1 : table 접히고 editor만 보임 -->
    <!-- layout_type_2 : editor 접히고 table만 보임 -->
    <!-- layout_type_4 : grid 없앰 -->
    <ProcessTop
        :readOnly="true"
    />
    <div ref="topPanel" class="topPanel">
      <IssueList/>
      <ReadOnlyEditor/>
      <SideBar/>
    </div>
    <div v-resizable="{ target: 'topPanel' }" class="divider">
      <div class="divider_btn"></div>
    </div>
    <Loading :visible="loading" />
  </div>
</template>

<script>
import {ref, onMounted, watch} from 'vue'
import ProcessTop from '@components/processEditor/Top';
import SideBar from "@nav_process/SideBar";
import CommNew from "@processEditor/CommNew";
import IssueList from '@components/protocolEditor/protocolIssueList';
import ReadOnlyEditor from "@components/visualization/index_readonly";
import Loading from '@common/loading.vue';

import {createNamespacedHelpers} from 'vuex';
const Hub = createNamespacedHelpers('Hub');
import {v4} from "uuid";

export default {
  mixins: [CommNew],
  components: {
    ProcessTop,
    ReadOnlyEditor,
    SideBar,
    IssueList,
    Loading,
  },
  data() {
    return {
      firstBln: false,
      loading : false,
    }
  },
  computed: {
  },
  async mounted() {
    await this.releaseCheck(); //공개여부 체크
    if (this.$route.query.processId == "NaN") {
      this.$router.push({path: `/visualization/gate`});
      return;
    }
    let {user, $route: {query}} = this;
    this.setInitInfo({user, query});
    await this.setProcess_N_UserInfo();
    await this.initElements();
    this.firstBln = true;
  },
  watch: {
    async PROCESS_INFO() {
      if (!this.firstBln) return;
      await this.releaseCheck() //공개여부 체크
    },
  },
  methods: {
    ...Hub.mapMutations(
        [
          "setSelectedReleaseProcess","setExperimentResultMode"
        ]
    ),
    async releaseCheck() {
      try {
        this.loading = true;

        const targetProcess = await this.$wApi.process.release.get({
          processId : this.$route.query.processId
        });

        if(!targetProcess.idReleaseProcess ){
          window.alert(`<span class='text-14 fw-400'>공개한 공정도가 아닙니다.</span> <h6 class='text-16 fw-600 mt-1' style='text-align:center;'>공정도목록으로 이동합니다.</h6>`,{
              okTitle: "확인",
              okVariant: "platform",
            });
          this.editorType = 'gate';
          this.$router.push({
            path : '/visualization/gate', query : {editorType : 'gate'}
          });
        }else{
          this.setSelectedReleaseProcess(targetProcess)
        }
      }catch (e){
        alert(e);
      }finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style lang="scss">
.process-editor .process-editor-top {
  grid-area: top;
}
</style>

<style lang="scss" scoped>
  @import "@/style/new/css/cyl.common.css";
</style>